
<template>
  <div>
    <v-card
      style="border-radius:12px"
      class="rounded-0 mb-3"
      flat
    >
      <v-card-title>
        Conclusão da etapa
      </v-card-title>
      <v-card-text class="ml-3">
        <v-row>
          <v-switch
            class="mt-2"
            v-model="has_conclusion"
            label="Configure o evento após a conclusão da etapa"
            color="success"
            inset
            dense
          ></v-switch>
        </v-row>
        <v-row class="flex-column mb-3">
          <span class="mb-2">Todos os usuários dessa lista irão receber todas as notificações sobre esse formulário por email</span>
          <v-autocomplete
              class="mb-n4"
              outlined
              dense
              v-model="users_to_send_notifications"
              label="Lista de usuários"
              :items="users"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
        </v-row>
        <v-row class="d-flex">
          <v-switch
            class="mr-4 mt-0"
            v-model="attach_pdf"
            label="Anexar PDF no e-mail?"
            color="success"
            inset
            dense
          ></v-switch>
          <v-switch
            class="mt-0"
            v-model="send_push_notifications"
            label="Enviar push notifications para os próximos responsáveis?"
            color="success"
            inset
            dense
          ></v-switch>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "ConclusionStepConfig",
  data() {
    return {
      users: [],
      users_to_send_notifications: false,
      attach_pdf: false,
      send_push_notifications: false
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>